(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cz-b2b-order"] && !Shopify.designMode) return;
  try {
    
  class CzB2bOrder extends HTMLElement {
    static validAddition(quantity, current, minimum, increment, maximum) {
      if (!Number.isSafeInteger(quantity) || quantity < 0 || !Number.isSafeInteger(current) || current < 0 || !Number.isSafeInteger(minimum) || minimum < 1 || !Number.isSafeInteger(increment) || increment < 1) return false;
      if (quantity === 0) return true;
      const total = current + quantity;
      return Number.isSafeInteger(total) && total >= minimum && total % increment === 0 && (maximum === null || total <= maximum);
    }

    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.form = this.querySelector('[data-cz-b2b-order-form]');
      this.inputs = [...this.querySelectorAll('[data-cz-b2b-quantity]')];
      this.status = this.querySelector('[data-cz-b2b-status]');
      this.button = this.querySelector('[data-cz-b2b-submit]');
      this.search = this.querySelector('[data-cz-b2b-search]');
      this.locked = false;
      this.pending = false;
      this.inputs.forEach((input) => { input.disabled = input.dataset.available !== 'true'; });
      this.search.disabled = false;
      this.button.disabled = false;
      this.search.addEventListener('input', () => {
        const query = this.search.value.trim().toLocaleLowerCase();
        let matches = 0;
        this.querySelectorAll('[data-cz-b2b-row]').forEach((row) => {
          row.hidden = !row.dataset.search.includes(query);
          if (!row.hidden) matches += 1;
        });
        this.querySelector('[data-cz-b2b-no-match]').hidden = matches > 0;
      }, { signal });
      this.inputs.forEach((input) => input.addEventListener('input', () => this.validate(input), { signal }));
      this.form.addEventListener('submit', (event) => this.submit(event), { signal });
      this.onCartChange = () => {
        if (this.locked) return;
        this.freeze();
        this.status.textContent = this.dataset.success;
      };
      document.addEventListener('cz:cart:updated', this.onCartChange, { signal });
    }

    disconnectedCallback() {
      document.removeEventListener('cz:cart:updated', this.onCartChange);
      this.controller?.abort();
      this.ready = false;
    }

    validate(input) {
      const valid = CzB2bOrder.validAddition(input.value === '' ? NaN : Number(input.value), Number(input.dataset.inCart), Number(input.dataset.minimum), Number(input.dataset.increment), input.dataset.maximum === '' ? null : Number(input.dataset.maximum));
      input.setCustomValidity(valid ? '' : this.dataset.rules);
      return valid;
    }

    freeze() {
      this.locked = true;
      this.button.disabled = true;
      this.inputs.forEach((input) => { input.disabled = true; });
      const refresh = this.querySelector('[data-cz-b2b-refresh]');
      refresh.hidden = false;
      refresh.addEventListener('click', (event) => { event.preventDefault(); window.location.reload(); }, { once: true, signal: this.controller?.signal });
    }

    setBusy(busy) {
      this.button.disabled = busy || this.locked;
      this.inputs.forEach((input) => { input.disabled = busy || this.locked || input.dataset.available !== 'true'; });
    }

    updateCartQuantities(cart) {
      if (!Array.isArray(cart.items)) throw new Error();
      const quantities = new Map();
      for (const item of cart.items) {
        const id = Number(item.variant_id || item.id);
        const quantity = item.quantity;
        if (!Number.isSafeInteger(id) || id < 1 || !Number.isSafeInteger(quantity) || quantity < 0) throw new Error();
        const total = (quantities.get(id) || 0) + quantity;
        if (!Number.isSafeInteger(total)) throw new Error();
        quantities.set(id, total);
      }
      this.inputs.forEach((input) => {
        const quantity = quantities.get(Number(input.dataset.variant)) || 0;
        input.dataset.inCart = String(quantity);
        const label = input.closest('[data-cz-b2b-row]').querySelector('[data-cz-b2b-in-cart]');
        if (label) label.textContent = this.dataset.inCartLabel.replace('[quantity]', String(quantity));
      });
    }

    async submit(event) {
      event.preventDefault();
      if (this.locked || this.pending) return;
      const activeInputs = this.inputs.filter((input) => !input.disabled);
      if (!window.CzCart?.addItems) { this.status.textContent = this.dataset.error; return; }
      const controller = this.controller;
      this.pending = true;
      this.setBusy(true);
      this.status.textContent = '';
      this.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(this.dataset.cartUrl, { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
        if (!response.ok) throw new Error();
        const cart = await response.json();
        if (controller.signal.aborted || this.controller !== controller || this.locked) return;
        this.updateCartQuantities(cart);
        const invalid = activeInputs.find((input) => !this.validate(input));
        if (invalid) {
          this.setBusy(false);
          this.status.textContent = this.dataset.rules;
          invalid.closest('[data-cz-b2b-row]').hidden = false;
          invalid.reportValidity();
          return;
        }
        const items = activeInputs.filter((input) => Number(input.value) > 0).map((input) => ({ id: Number(input.dataset.variant), quantity: Number(input.value) }));
        if (!items.length) { this.status.textContent = this.dataset.empty; return; }
        this.freeze();
        await window.CzCart.addItems(items, { successTitle: this.dataset.success });
        if (controller.signal.aborted || this.controller !== controller) return;
        this.status.textContent = this.dataset.success;
      } catch {
        if (controller.signal.aborted || this.controller !== controller) return;
        this.status.textContent = this.dataset.error;
        this.status.focus();
      } finally {
        if (!controller.signal.aborted && this.controller === controller) {
          this.pending = false;
          this.setBusy(false);
          this.removeAttribute('aria-busy');
        }
      }
    }
  }
  if (!customElements.get('cz-b2b-order')) customElements.define('cz-b2b-order', CzB2bOrder);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cz-product-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.czInitialized === 'true') return;
      root.dataset.czInitialized = 'true';

      const options = () => Array.from(root.querySelectorAll('[data-cz-finder-option]'));
      const selectedOptions = () => options().filter((option) => option.classList.contains('is-selected'));
      const pageScope = root.closest('main') || document;
      const results = () => pageScope.querySelector('[data-cz-filter-results]');
      const status = root.querySelector('[data-cz-finder-status]');
      const countTarget = root.querySelector('[data-cz-results-count]');
      const resetButton = root.querySelector('[data-cz-filter-reset]');
      const selectionSummary = root.querySelector('[data-cz-selection-summary]');
      const selectionList = root.querySelector('[data-cz-selection-list]');
      const showResultsButton = root.querySelector('[data-cz-show-results]');
      const allBrandsButton = root.querySelector('[data-cz-select-all-brands]');
      const productIndexNode = root.querySelector('[data-cz-product-index-bootstrap]');
      const selectionCartBar = root.querySelector('[data-cz-selection-cart-bar]');
      const selectedProductCount = root.querySelector('[data-cz-selected-product-count]');
      const addSelectedButton = root.querySelector('[data-cz-add-selected]');
      const addSelectedLabel = root.querySelector('[data-cz-add-selected-label]');
      const packProgress = root.querySelector('[data-cz-pack-progress]');
      const addSelectedDefaultLabel = addSelectedLabel?.textContent || 'Agregar al carro';
      const normalizeValues = (value) => {
        if (Array.isArray(value)) return value.map(String).filter(Boolean);
        if (value === null || value === undefined || value === '') return [];
        return [String(value)];
      };
      const normalizeProduct = (product) => ({
        ...product,
        types: normalizeValues(product.types),
        needs: normalizeValues(product.needs),
        features: normalizeValues(product.features),
      });
      const expectedProductCount = Number(root.dataset.czIndexCount);
      const productIndexPages = Math.max(1, Number(root.dataset.czIndexPages) || 1);
      let productPool = [];
      try {
        productPool = JSON.parse(productIndexNode?.textContent || '[]').map(normalizeProduct);
      } catch (error) {
        productPool = [];
      }
      let productIndexComplete = productIndexPages <= 1
        && (!Number.isFinite(expectedProductCount) || productPool.length >= expectedProductCount);
      const stepTwoGroups = new Set(['need', 'feature', 'audience']);
      let activeRequest;
      let disposed = false;
      const lifetimeController = new AbortController();
      const productSelections = new Map();
      let selectionCartBusy = false;

      const loadRemainingProductIndex = async () => {
        const indexUrl = root.dataset.czIndexUrl;
        if (productIndexComplete || !indexUrl || productIndexPages <= 1) return;

        let nextPage = 2;
        const loadedProducts = [];

        const loadPage = async () => {
          while (nextPage <= productIndexPages) {
            const pageNumber = nextPage;
            nextPage += 1;
            const url = new URL(indexUrl, window.location.origin);
            url.searchParams.set('page', String(pageNumber));
            const response = await fetch(url.toString(), {
              headers: { 'X-Requested-With': 'XMLHttpRequest' },
              signal: lifetimeController.signal,
            });
            if (!response.ok) throw new Error(String(response.status));
            const payload = await response.json();
            if (disposed) return;
            if (!Array.isArray(payload.products) || Number(payload.page) !== pageNumber) {
              throw new Error('invalid-product-index');
            }
            loadedProducts.push(...payload.products.map(normalizeProduct));
          }
        };

        try {
          const workerCount = Math.min(4, productIndexPages - 1);
          await Promise.all(Array.from({ length: workerCount }, loadPage));
          if (disposed) return;
          const productsById = new Map(
            [...productPool, ...loadedProducts].map((product) => [String(product.id), product])
          );
          const completePool = Array.from(productsById.values());
          if (Number.isFinite(expectedProductCount) && completePool.length < expectedProductCount) {
            throw new Error('incomplete-product-index');
          }
          productPool = completePool;
          productIndexComplete = true;
          syncDynamicOptions({ preserveSelection: true });
          syncSelection();
        } catch (error) {
          productIndexComplete = false;
        }
      };

      const scrollBehavior = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

      const countText = (count) => {
        if (count === 1) return root.dataset.czCountOne || '1';
        return (root.dataset.czCountOther || '__count__').replace('__count__', String(count));
      };

      const selectedProductText = (count) => {
        const template = count === 1 ? root.dataset.czSelectedOne : root.dataset.czSelectedOther;
        return (template || '__count__ productos seleccionados').replace('__count__', String(count));
      };

      const addSelectedText = (count) => {
        if (count <= 0) return addSelectedDefaultLabel;
        const template = count === 1 ? root.dataset.czAddSelectedOne : root.dataset.czAddSelectedOther;
        return (template || addSelectedDefaultLabel).replace('__count__', String(count));
      };

      const selectedUnitCount = () => Array.from(productSelections.values()).reduce(
        (total, selection) => total + Math.max(1, Number(selection.quantity) || 1),
        0
      );

      const syncPackProgress = (count) => {
        if (!packProgress) return;
        const firstQuantity = Number(packProgress.dataset.firstQuantity) || 3;
        const firstDiscount = Number(packProgress.dataset.firstDiscount) || 12;
        const secondQuantity = Number(packProgress.dataset.secondQuantity) || 5;
        const secondDiscount = Number(packProgress.dataset.secondDiscount) || 18;
        const message = packProgress.querySelector('[data-cz-pack-progress-message]');
        const fill = packProgress.querySelector('[data-cz-pack-progress-fill]');
        let text = '';
        let progress = 0;

        if (count < firstQuantity) {
          text = (packProgress.dataset.needTemplate || `Agrega __count__ más y ahorra ${firstDiscount}%`)
            .replace('__count__', String(firstQuantity - count));
          progress = count / firstQuantity;
        } else if (count < secondQuantity) {
          text = (packProgress.dataset.nextTemplate || `Ahorro ${firstDiscount}% activado · agrega __count__ más para llegar a ${secondDiscount}%`)
            .replace('__count__', String(secondQuantity - count));
          progress = count / secondQuantity;
        } else {
          text = packProgress.dataset.bestTemplate || `Mejor ahorro activado: ${secondDiscount}%`;
          progress = 1;
        }

        if (message) message.textContent = text;
        if (fill) fill.style.width = `${Math.min(100, Math.max(0, progress * 100))}%`;
      };

      const syncProductSelectionUI = () => {
        pageScope.querySelectorAll('[data-cz-selectable-card]').forEach((card) => {
          const variantId = card.dataset.czVariantId;
          const selection = productSelections.get(variantId);
          const selectButton = card.querySelector('[data-cz-product-select]');
          const quantity = card.querySelector('[data-cz-product-quantity]');
          const value = card.querySelector('[data-cz-selection-value]');
          const isSelected = Boolean(selection);

          card.classList.toggle('is-selected', isSelected);
          if (selectButton) {
            selectButton.hidden = isSelected;
            selectButton.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
            const selectButtonLabel = selectButton.querySelector('span');
            if (selectButtonLabel) selectButtonLabel.textContent = 'Agregar a la selección';
          }
          if (quantity) quantity.hidden = !isSelected;
          if (value) value.textContent = String(selection?.quantity || 1);
        });

        const selectedProducts = productSelections.size;
        const selectedUnits = selectedUnitCount();
        root.classList.toggle('has-product-selection', selectedProducts > 0);
        if (selectionCartBar) selectionCartBar.hidden = selectedProducts === 0;
        if (selectedProductCount) selectedProductCount.textContent = selectedProductText(selectedUnits);
        if (addSelectedLabel && !selectionCartBusy) addSelectedLabel.textContent = addSelectedText(selectedUnits);
        syncPackProgress(selectedUnits);
      };

      const selectProduct = (card, quantity) => {
        const variantId = card?.dataset.czVariantId;
        if (!variantId) return;

        if (quantity <= 0) {
          productSelections.delete(variantId);
        } else {
          productSelections.set(variantId, {
            id: variantId,
            quantity: Math.min(99, quantity),
            title: card.dataset.czProductTitle || '',
          });
        }
        syncProductSelectionUI();
      };

      const valuesForProduct = (product, key) => {
        if (key === 'filter.p.m.custom.tipo_producto') return product.types;
        if (key === 'filter.p.m.custom.necesidades') return product.needs;
        if (key === 'filter.p.m.custom.caracteristicas') return product.features;
        if (key === 'filter.p.vendor') return normalizeValues(product.vendor);
        return [];
      };

      const matchesChoices = (product, choices) => {
        const filters = new Map();
        choices.forEach((choice) => {
          const key = choice.dataset.czFilterKey;
          const values = [
            choice.dataset.czFilterValue,
            choice.dataset.czFilterValueSecondary,
          ].filter(Boolean);
          if (!key || values.length === 0) return;
          if (!filters.has(key)) filters.set(key, new Set());
          values.forEach((value) => filters.get(key).add(value));
        });

        return Array.from(filters.entries()).every(([key, acceptedValues]) => {
          const productValues = valuesForProduct(product, key);
          return productValues.some((value) => acceptedValues.has(value));
        });
      };

      const selectionHasProducts = (choices) => {
        if (!productIndexComplete || productPool.length === 0) return true;
        return productPool.some((product) => matchesChoices(product, choices));
      };

      const upstreamChoicesFor = (option) => {
        const group = option.dataset.czFilterGroup;
        const key = option.dataset.czFilterKey;
        const selected = selectedOptions().filter((candidate) => candidate !== option);

        if (stepTwoGroups.has(group)) {
          return selected.filter((candidate) => {
            const candidateGroup = candidate.dataset.czFilterGroup;
            if (candidateGroup === 'type') return true;
            return stepTwoGroups.has(candidateGroup) && candidate.dataset.czFilterKey !== key;
          });
        }

        if (group === 'brand') {
          return selected.filter((candidate) => candidate.dataset.czFilterGroup !== 'brand');
        }

        return selected;
      };

      const optionCanBeSelected = (option) => {
        if (!productIndexComplete || productPool.length === 0 || option.dataset.czFilterGroup === 'type') return true;
        return selectionHasProducts([...upstreamChoicesFor(option), option]);
      };

      const setOptionSelected = (option, selected) => {
        option.classList.toggle('is-selected', selected);
        option.setAttribute('aria-pressed', selected ? 'true' : 'false');
      };

      const syncDynamicOptions = ({ preserveSelection = false } = {}) => {
        if (!productIndexComplete || productPool.length === 0) return;

        for (let pass = 0; pass < 3; pass += 1) {
          let selectionChanged = false;
          options()
            .filter((option) => stepTwoGroups.has(option.dataset.czFilterGroup))
            .forEach((option) => {
              const available = optionCanBeSelected(option);
              if (!preserveSelection && !available && option.classList.contains('is-selected')) {
                setOptionSelected(option, false);
                selectionChanged = true;
              }
              const visible = available || option.classList.contains('is-selected');
              option.hidden = !visible;
              option.setAttribute('aria-hidden', visible ? 'false' : 'true');
            });
          if (!selectionChanged) break;
        }

        options()
          .filter((option) => option.dataset.czFilterGroup === 'brand')
          .forEach((option) => {
            const available = optionCanBeSelected(option);
            if (!preserveSelection && !available && option.classList.contains('is-selected')) setOptionSelected(option, false);
            const visible = available || option.classList.contains('is-selected');
            option.hidden = !visible;
            option.setAttribute('aria-hidden', visible ? 'false' : 'true');
          });

        root.querySelectorAll('[data-cz-dynamic-facet-group]').forEach((group) => {
          group.hidden = !group.querySelector('[data-cz-finder-option]:not([hidden])');
        });

        const hasStepTwoOptions = Boolean(
          root.querySelector('[data-cz-dynamic-facet-group] [data-cz-finder-option]:not([hidden])')
        );
        const emptyStep = root.querySelector('[data-cz-empty-step]');
        if (emptyStep) emptyStep.hidden = hasStepTwoOptions;
      };

      const syncCount = (count, loading = false) => {
        if (loading) {
          if (status) status.textContent = root.dataset.czLoading || '';
          if (showResultsButton) showResultsButton.disabled = true;
          return;
        }
        const safeCount = Number.isNaN(count) ? 0 : count;
        if (status) status.textContent = countText(safeCount);
        if (countTarget) {
          countTarget.textContent = String(safeCount);
          countTarget.hidden = false;
        }
        if (showResultsButton) showResultsButton.disabled = false;
      };

      const syncSelection = () => {
        const selected = selectedOptions();
        const brandOptions = options().filter(
          (option) => option.dataset.czFilterGroup === 'brand' && !option.hidden
        );
        const allBrandsSelected = brandOptions.length > 0
          && brandOptions.every((option) => option.classList.contains('is-selected'));
        if (allBrandsButton) {
          allBrandsButton.classList.toggle('is-selected', allBrandsSelected);
          allBrandsButton.setAttribute('aria-pressed', allBrandsSelected ? 'true' : 'false');
        }
        if (resetButton) resetButton.hidden = selected.length === 0;
        if (selectionSummary) selectionSummary.hidden = selected.length === 0;
        if (!selectionList) return;
        selectionList.replaceChildren();

        selected.forEach((option) => {
          const chip = document.createElement('button');
          const label = option.dataset.czFilterLabel || option.textContent.trim();
          chip.className = 'cz-product-finder__chip';
          chip.type = 'button';
          chip.dataset.czRemoveOption = option.id;
          chip.setAttribute('aria-label', `${root.dataset.czRemove || ''} ${label}`.trim());

          const chipLabel = document.createElement('span');
          chipLabel.textContent = label;
          const chipClose = document.createElement('span');
          chipClose.setAttribute('aria-hidden', 'true');
          chipClose.textContent = '×';
          chip.append(chipLabel, chipClose);
          selectionList.append(chip);
        });
      };

      const catalogUrl = () => {
        const localeRoot = window.Shopify?.routes?.root || '/';
        const path = `${localeRoot.replace(/\/?$/, '/')}collections/all`;
        const url = new URL(path, window.location.origin);

        url.search = '';

        selectedOptions().forEach((option) => {
          const key = option.dataset.czFilterKey;
          const value = option.dataset.czFilterValue;
          const secondaryValue = option.dataset.czFilterValueSecondary;
          if (key && value) url.searchParams.append(key, value);
          if (key && secondaryValue) url.searchParams.append(key, secondaryValue);
        });
        return url;
      };

      const syncAddress = ({ replace = false } = {}) => {
        const pageUrl = new URL(window.location.href);
        Array.from(pageUrl.searchParams.keys()).forEach((key) => {
          if (key.startsWith('filter.') || ['finder_type', 'page', 'sort_by', 'sections', 'section_id'].includes(key)) {
            pageUrl.searchParams.delete(key);
          }
        });

        selectedOptions().forEach((option) => {
          const key = option.dataset.czFilterKey;
          const value = option.dataset.czFilterValue;
          const secondaryValue = option.dataset.czFilterValueSecondary;
          if (key && value) pageUrl.searchParams.append(key, value);
          if (key && secondaryValue) pageUrl.searchParams.append(key, secondaryValue);
        });

        const nextAddress = `${pageUrl.pathname}${pageUrl.search}${pageUrl.hash}`;
        const currentAddress = `${window.location.pathname}${window.location.search}${window.location.hash}`;
        if (nextAddress !== currentAddress) {
          window.history[replace ? 'replaceState' : 'pushState'](window.history.state, '', nextAddress);
        }
      };

      const restoreSelectionFromAddress = () => {
        const params = new URL(window.location.href).searchParams;
        options().forEach((option) => {
          const values = option.dataset.czFilterKey ? params.getAll(option.dataset.czFilterKey) : [];
          const selected = option.dataset.czFilterKey && option.dataset.czFilterValue
            ? values.includes(option.dataset.czFilterValue)
              && (!option.dataset.czFilterValueSecondary || values.includes(option.dataset.czFilterValueSecondary))
            : false;
          option.classList.toggle('is-selected', selected);
          option.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
      };

      const updateResults = async () => {
        if (disposed) return;
        const currentResults = results();
        if (!currentResults) return;

        activeRequest?.abort();
        const requestController = new AbortController();
        activeRequest = requestController;
        currentResults.classList.add('is-updating');
        currentResults.setAttribute('aria-busy', 'true');
        syncCount(Number(currentResults.dataset.czResultCount), true);

        const publicUrl = catalogUrl();
        const requestUrl = new URL(publicUrl);
        requestUrl.searchParams.set('view', 'finder-results');

        try {
          const response = await fetch(requestUrl.toString(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            signal: requestController.signal,
          });
          if (!response.ok) throw new Error(String(response.status));
          if (activeRequest !== requestController) return;

          const html = await response.text();
          if (activeRequest !== requestController) return;
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const nextResults = parsed.querySelector('[data-cz-filter-results]');
          const nextWrapper = nextResults?.closest('.shopify-section');
          const currentWrapper = currentResults.closest('.shopify-section');
          if (!nextWrapper || !nextResults || !currentWrapper) throw new Error('invalid-section');

          const resultsLink = nextWrapper.querySelector('[data-cz-results-link]');
          if (resultsLink) resultsLink.setAttribute('href', `${publicUrl.pathname}${publicUrl.search}`);
          currentWrapper.replaceWith(nextWrapper);
          syncCount(Number(nextResults.dataset.czResultCount));
          syncProductSelectionUI();
        } catch (error) {
          if (error.name === 'AbortError' || activeRequest !== requestController) return;
          const visibleResults = results();
          visibleResults?.classList.remove('is-updating');
          visibleResults?.setAttribute('aria-busy', 'false');
          // Keep the requested filters and replace stale cards with an explicit retry.
          const errorPanel = document.createElement('div');
          errorPanel.className = 'cz-filter-results__empty';
          const message = document.createElement('p');
          message.textContent = root.dataset.czError || '';
          const retry = document.createElement('button');
          retry.type = 'button';
          retry.className = 'cz-btn cz-btn--dark';
          retry.dataset.czRetryResults = '';
          retry.textContent = 'Reintentar';
          errorPanel.append(message, retry);
          visibleResults?.replaceChildren(errorPanel);
          if (countTarget) {
            countTarget.textContent = '';
            countTarget.hidden = true;
          }
          if (status) status.textContent = root.dataset.czError || '';
          if (showResultsButton) showResultsButton.disabled = false;
        }
      };

      const clearAll = () => {
        options().forEach((candidate) => {
          candidate.classList.remove('is-selected');
          candidate.setAttribute('aria-pressed', 'false');
        });
        syncDynamicOptions();
        syncSelection();
        syncAddress();
        updateResults();
      };

      const handleRootClick = (event) => {
        if (disposed) return;
        if (event.target.closest('[data-cz-select-all-brands]')) {
          const brandOptions = options().filter(
            (candidate) => candidate.dataset.czFilterGroup === 'brand' && !candidate.hidden
          );
          const allBrandsSelected = brandOptions.length > 0
            && brandOptions.every((candidate) => candidate.classList.contains('is-selected'));
          brandOptions.forEach((candidate) => {
            candidate.classList.toggle('is-selected', !allBrandsSelected);
            candidate.setAttribute('aria-pressed', allBrandsSelected ? 'false' : 'true');
          });
          syncDynamicOptions();
          syncSelection();
          syncAddress();
          updateResults();
          return;
        }

        const option = event.target.closest('[data-cz-finder-option]');
        if (option) {
          const selected = option.classList.contains('is-selected');
          if (!selected && !optionCanBeSelected(option)) return;
          if (option.dataset.czFilterMode === 'single' && !selected) {
            options()
              .filter((candidate) => candidate.dataset.czFilterGroup === option.dataset.czFilterGroup)
              .forEach((candidate) => {
                candidate.classList.remove('is-selected');
                candidate.setAttribute('aria-pressed', 'false');
              });
          }
          setOptionSelected(option, !selected);
          syncDynamicOptions();
          syncSelection();
          syncAddress();
          updateResults();
          return;
        }

        const remove = event.target.closest('[data-cz-remove-option]');
        if (remove) {
          document.getElementById(remove.dataset.czRemoveOption)?.click();
          return;
        }

        if (event.target.closest('[data-cz-filter-reset]')) {
          clearAll();
          return;
        }

        if (event.target.closest('[data-cz-show-results]')) {
          const currentResults = results();
          const behavior = scrollBehavior();
          currentResults?.scrollIntoView({ behavior, block: 'start' });
          const heading = currentResults?.querySelector('h2, h3');
          if (heading) {
            heading.setAttribute('tabindex', '-1');
            window.setTimeout(() => heading.focus({ preventScroll: true }), behavior === 'smooth' ? 450 : 0);
          }
        }
      };

      const handlePageClick = async (event) => {
        if (disposed) return;
        if (event.target.closest('[data-cz-retry-results]')) {
          event.preventDefault();
          updateResults();
          return;
        }
        const productCard = event.target.closest('[data-cz-selectable-card]');
        const selectButton = event.target.closest('[data-cz-product-select]');
        const selectionMinus = event.target.closest('[data-cz-selection-minus]');
        const selectionPlus = event.target.closest('[data-cz-selection-plus]');
        if (productCard && (selectButton || selectionMinus || selectionPlus)) {
          event.preventDefault();
          const selection = productSelections.get(productCard.dataset.czVariantId);
          if (selectButton) selectProduct(productCard, 1);
          if (selectionMinus) selectProduct(productCard, (selection?.quantity || 1) - 1);
          if (selectionPlus) selectProduct(productCard, (selection?.quantity || 0) + 1);
          return;
        }

        const addSelected = event.target.closest('[data-cz-add-selected]');
        if (addSelected) {
          event.preventDefault();
          if (selectionCartBusy || productSelections.size === 0) return;

          selectionCartBusy = true;
          addSelected.disabled = true;
          addSelected.setAttribute('aria-busy', 'true');
          if (addSelectedLabel) addSelectedLabel.textContent = root.dataset.czAdding || 'Agregando…';

          try {
            if (typeof window.CzCart?.addItems !== 'function') throw new Error(root.dataset.czCartError || '');
            await window.CzCart.addItems(Array.from(productSelections.values()), {
              successTitle: root.dataset.czAdded || 'Productos agregados correctamente.',
            });
            if (disposed) return;
            productSelections.clear();
            syncProductSelectionUI();
            if (status) status.textContent = root.dataset.czAdded || '';
          } catch (error) {
            if (disposed) return;
            if (status) status.textContent = error.message || root.dataset.czCartError || '';
          } finally {
            if (!disposed) {
              selectionCartBusy = false;
              addSelected.disabled = false;
              addSelected.removeAttribute('aria-busy');
              if (addSelectedLabel) addSelectedLabel.textContent = addSelectedText(selectedUnitCount());
            }
          }
          return;
        }

        const loadMore = event.target.closest('[data-cz-load-more]');
        if (loadMore) {
          event.preventDefault();
          if (loadMore.getAttribute('aria-busy') === 'true') return;

          const currentResults = results();
          const currentGrid = currentResults?.querySelector('.cz-products-grid');
          const currentMore = loadMore.closest('[data-cz-load-more-wrap]');
          if (!currentResults || !currentGrid || !currentMore) return;

          loadMore.setAttribute('aria-busy', 'true');
          loadMore.setAttribute('aria-disabled', 'true');

          try {
            const response = await fetch(loadMore.href, {
              headers: { 'X-Requested-With': 'XMLHttpRequest' },
              signal: lifetimeController.signal,
            });
            if (!response.ok) throw new Error(String(response.status));

            const html = await response.text();
            if (disposed) return;
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const nextResults = parsed.querySelector('[data-cz-filter-results]');
            const nextGrid = nextResults?.querySelector('.cz-products-grid');
            if (!nextGrid) throw new Error('invalid-results-page');

            const fragment = document.createDocumentFragment();
            Array.from(nextGrid.children).forEach((card) => fragment.append(card));
            currentGrid.append(fragment);
            syncProductSelectionUI();

            const nextLoadMore = nextResults.querySelector('[data-cz-load-more]');
            if (nextLoadMore) currentMore.replaceChildren(nextLoadMore);
            else currentMore.remove();

          } catch (error) {
            if (disposed) return;
            loadMore.removeAttribute('aria-busy');
            loadMore.removeAttribute('aria-disabled');
            if (status) status.textContent = root.dataset.czError || '';
          }
          return;
        }

        const externalReset = event.target.closest('[data-cz-filter-reset]');
        if (externalReset && !root.contains(externalReset)) clearAll();
      };
      root.addEventListener('click', handleRootClick);
      pageScope.addEventListener('click', handlePageClick);

      const initialCount = Number(results()?.dataset.czResultCount);
      restoreSelectionFromAddress();
      syncDynamicOptions({ preserveSelection: true });
      syncAddress({ replace: true });
      syncSelection();
      syncProductSelectionUI();
      if (!Number.isNaN(initialCount)) syncCount(initialCount);
      if (selectedOptions().length > 0) updateResults();
      loadRemainingProductIndex();

      const restoreHistory = () => {
        if (!root.isConnected) return;
        restoreSelectionFromAddress();
        syncDynamicOptions({ preserveSelection: true });
        syncSelection();
        updateResults();
      };
      window.addEventListener('popstate', restoreHistory);
      (root.closest('.shopify-section') || root).addEventListener('shopify:section:unload', () => {
        disposed = true;
        activeRequest?.abort();
        activeRequest = null;
        lifetimeController.abort();
        root.removeEventListener('click', handleRootClick);
        pageScope.removeEventListener('click', handlePageClick);
        window.removeEventListener('popstate', restoreHistory);
        productSelections.clear();
        delete root.dataset.czInitialized;
      }, { once: true });
    };

    const initializeAll = () => {
      document.querySelectorAll('[data-cz-product-finder]').forEach(initialize);
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cz-shop-navigator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.czShopFinderReady) return;
    window.czShopFinderReady = true;

    const selections = new Map();
    let activeRequest;

    const finder = () => document.querySelector('[data-cz-shop-finder]');
    const results = () => document.querySelector('[data-cz-filter-results]');
    const resultsCta = () => finder()?.querySelector('[data-cz-show-results]');

    const smoothScrollTo = (element) => {
      if (!element) return;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      element.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
    };

    const syncResultsCta = (count, loading = false) => {
      const button = resultsCta();
      if (!button) return;
      button.hidden = selections.size === 0;
      button.disabled = loading;
      const countLabel = button.querySelector('[data-cz-results-count]');
      if (countLabel && Number.isFinite(count)) countLabel.textContent = `(${count})`;
    };

    const announce = (message) => {
      const status = finder()?.querySelector('[data-cz-finder-status]');
      if (status) status.textContent = message;
    };

    const announceCount = (count) => {
      const root = finder();
      if (!root || Number.isNaN(count)) return;
      const template = count === 1 ? root.dataset.czCountOne : root.dataset.czCountOther;
      announce((template || '').replace('__count__', String(count)));
      syncResultsCta(count, false);
    };

    const syncControls = () => {
      document.querySelectorAll('[data-cz-filter-option]').forEach((button) => {
        const selection = selections.get(button.dataset.czFilterGroup);
        const isType = button.dataset.czFilterGroup === 'type';
        const active = Boolean(selection) && (isType
          ? selection.url === button.dataset.czFilterUrl
          : selection.key === button.dataset.czFilterKey && selection.value === button.dataset.czFilterValue);
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      document.querySelectorAll('[data-cz-selection-label]').forEach((label) => {
        const selection = selections.get(label.dataset.czSelectionLabel);
        label.textContent = selection ? selection.label : '';
      });
    };

    const catalogUrl = () => {
      const localeRoot = window.Shopify?.routes?.root || '/';
      const typeSelection = selections.get('type');
      const path = typeSelection?.url || `${localeRoot.replace(/\/?$/, '/')}collections/all`;
      const url = new URL(path, window.location.origin);

      selections.forEach((selection, group) => {
        if (group !== 'type' && selection.key && selection.value) {
          url.searchParams.set(selection.key, selection.value);
        }
      });

      return url;
    };

    const updateResults = async () => {
      const currentResults = results();
      const root = finder();
      if (!currentResults || !root) return;

      const sectionId = currentResults.dataset.czSectionId;
      if (!sectionId) return;

      activeRequest?.abort();
      activeRequest = new AbortController();
      currentResults.classList.add('is-updating');
      currentResults.setAttribute('aria-busy', 'true');
      syncResultsCta(Number(currentResults.dataset.czResultCount), true);
      announce(root.dataset.czLoading || '');

      const publicUrl = catalogUrl();
      const requestUrl = new URL(publicUrl);
      requestUrl.searchParams.set('sections', sectionId);

      try {
        const response = await fetch(requestUrl.toString(), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: activeRequest.signal,
        });
        if (!response.ok) throw new Error(String(response.status));

        const payload = await response.json();
        const html = payload[sectionId];
        if (!html) throw new Error('missing-section');

        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const nextWrapper = parsed.getElementById(`shopify-section-${sectionId}`) || parsed.querySelector('.shopify-section');
        const nextResults = nextWrapper?.querySelector('[data-cz-filter-results]');
        const currentWrapper = currentResults.closest('.shopify-section');
        if (!nextWrapper || !nextResults || !currentWrapper) throw new Error('invalid-section');

        const resultsLink = nextWrapper.querySelector('[data-cz-results-link]');
        if (resultsLink) resultsLink.setAttribute('href', `${publicUrl.pathname}${publicUrl.search}`);
        currentWrapper.replaceWith(nextWrapper);
        announceCount(Number(nextResults.dataset.czResultCount));
      } catch (error) {
        if (error.name === 'AbortError') return;
        const visibleResults = results();
        visibleResults?.classList.remove('is-updating');
        visibleResults?.setAttribute('aria-busy', 'false');
        syncResultsCta(Number(visibleResults?.dataset.czResultCount), false);
        announce(root.dataset.czError || '');
      }
    };

    document.addEventListener('click', (event) => {
      const heroLink = event.target.closest('a[href="#encuentra-lo-que-buscas"]');
      if (heroLink) {
        event.preventDefault();
        const root = finder();
        if (root) {
          root.querySelector('.cz-shop-navigator__accordion')?.setAttribute('open', '');
          window.history.replaceState(null, '', '#encuentra-lo-que-buscas');
          smoothScrollTo(root);
        }
        return;
      }

      const showResults = event.target.closest('[data-cz-show-results]');
      if (showResults) {
        smoothScrollTo(results());
        return;
      }

      const reset = event.target.closest('[data-cz-filter-reset]');
      if (reset) {
        selections.clear();
        syncControls();
        syncResultsCta(Number(results()?.dataset.czResultCount), false);
        updateResults();
        return;
      }

      const option = event.target.closest('[data-cz-filter-option]');
      if (!option) return;

      const group = option.dataset.czFilterGroup;
      const current = selections.get(group);
      const next = {
        key: option.dataset.czFilterKey || '',
        value: option.dataset.czFilterValue || '',
        url: option.dataset.czFilterUrl || '',
        label: option.dataset.czFilterLabel || option.textContent.trim(),
      };
      const same = current && (group === 'type'
        ? current.url === next.url
        : current.key === next.key && current.value === next.value);

      if (same) selections.delete(group);
      else selections.set(group, next);
      syncControls();
      updateResults();
    });

    const initializeCount = () => {
      const count = Number(results()?.dataset.czResultCount);
      if (!Number.isNaN(count)) announceCount(count);
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeCount, { once: true });
    else initializeCount();

    document.addEventListener('shopify:section:load', () => {
      syncControls();
      initializeCount();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cz-splat-brand-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  let dialog, opener, drag;
  let zoom = 1, x = 0, y = 0, moved = false;
  const image = () => dialog.querySelector('[data-cz-splat-zoom-image]');
  const viewport = () => dialog.querySelector('.cz-splat-zoom-viewport');
  const paint = () => {
    const img = image(), view = viewport();
    const mx = Math.max(0, (img.offsetWidth * zoom - view.clientWidth) / 2);
    const my = Math.max(0, (img.offsetHeight * zoom - view.clientHeight) / 2);
    x = Math.max(-mx, Math.min(mx, x));
    y = Math.max(-my, Math.min(my, y));
    img.style.transform = `translate(${x}px, ${y}px) scale(${zoom})`;
  };
  const setZoom = (enlarge) => {
    zoom = enlarge ? Math.min(4, Math.max(2, 1080 / Math.max(1, image().offsetWidth))) : 1;
    x = 0; y = 0;
    dialog.classList.toggle('is-zoomed', enlarge);
    const button = dialog.querySelector('[data-cz-splat-zoom-scale]');
    button.setAttribute('aria-pressed', String(enlarge));
    button.textContent = enlarge ? '−' : '+';
    paint();
  };
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-cz-splat-zoom]');
    if (link) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const next = link.closest('.section-cz-splat-brand')?.querySelector('.cz-splat-zoom-dialog');
      if (!next || typeof next.showModal !== 'function') return;
      event.preventDefault();
      dialog = next; opener = link; drag = null; moved = false;
      image().src = link.href;
      image().alt = link.querySelector('img').alt;
      dialog.querySelector('[data-cz-splat-zoom-caption]').textContent = link.closest('figure').querySelector('figcaption strong').textContent;
      dialog.showModal();
      setZoom(false);
      document.documentElement.classList.add('cz-splat-zoom-open');
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('cz-splat-zoom-open');
        if (opener?.isConnected) opener.focus({preventScroll:true});
        dialog = null; opener = null; drag = null;
      }, {once:true});
      return;
    }
    if (!dialog) return;
    if (event.target.closest('[data-cz-splat-zoom-close]')) dialog.close();
    else if (event.target.closest('[data-cz-splat-zoom-scale]')) setZoom(zoom === 1);
    else if (event.target === image() && !moved) setZoom(zoom === 1);
    else if (event.target === viewport() && !moved) {
      if (zoom > 1) setZoom(false);
      else dialog.close();
    }
    moved = false;
  });
  document.addEventListener('pointerdown', (event) => {
    if (!dialog || !viewport().contains(event.target)) return;
    moved = false;
    if (zoom === 1) return;
    drag = {id:event.pointerId, sx:event.clientX, sy:event.clientY, x, y};
    viewport().setPointerCapture(event.pointerId);
  });
  document.addEventListener('pointermove', (event) => {
    if (!dialog || zoom === 1) return;
    if (drag && event.pointerId === drag.id) {
      const dx = event.clientX - drag.sx, dy = event.clientY - drag.sy;
      if (Math.abs(dx) + Math.abs(dy) > 5) moved = true;
      x = drag.x + dx; y = drag.y + dy; paint();
    }
  });
  document.addEventListener('pointerup', () => { drag = null; });
  document.addEventListener('pointercancel', () => { drag = null; moved = true; });
  window.addEventListener('resize', () => { if (dialog) setZoom(false); });
  document.addEventListener('shopify:section:unload', (event) => {
    if (dialog && event.target.contains(dialog)) dialog.close();
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
